import React, { useState, useEffect } from "react";
import "./home.css";
import Layout from "../../Components/Layout";

const Home = () => {
  const [showContent, setShowContent] = useState(false);
  const [showSlogan, setShowSlogan] = useState(false);

  useEffect(() => {
    let bubble = document.getElementById("bubble");
    bubble.classList.add("bubble-animate");

    // Show text content after 8 seconds.
    const contentTimer = setTimeout(() => {
      setShowContent(true);
      
      // Show slogan 1 second after main title appears
      const sloganTimer = setTimeout(() => {
        setShowSlogan(true);
      }, 1000);
      
      return () => clearTimeout(sloganTimer);
    }, 8000);

    return () => {
      clearTimeout(contentTimer);
    };
  }, []);

  const handleBubbleClick = () => {
    let bubble = document.getElementById("bubble");
    bubble.classList.remove("bubble-animate");
    bubble.classList.add("bubble-cancel");
    setShowContent(true);
    
    // Show slogan 1 second after bubble is clicked
    setTimeout(() => {
      setShowSlogan(true);
    }, 1000);
  };

  // Updated function to reveal text word by word with a slower delay
  const createRevealText = (text, startDelay = 0) => {
    return text.split(' ').map((word, index) => (
      <React.Fragment key={index}>
        <span 
          className="reveal-word" 
          style={{ animationDelay: `${startDelay + (index * 0.3)}s` }}>
          {word}
        </span>
        {" "}
      </React.Fragment>
    ));
  };

  return (
    <Layout>
      <div className="container">
        <div
          className="content-container"
          style={{
            opacity: showContent ? 1 : 0,
            pointerEvents: showContent ? "auto" : "none",
          }}
        >
          <div className="title-container">
            <h1 className="color-title">bubble computing</h1>
            <h2 
              className="slogan"
              style={{ minHeight: "2em" /* reserves space to avoid shifting */ }}
            >
              {showSlogan ? createRevealText("Blurring the lines between P & NP") : null}
            </h2>
          </div>
        </div>

        <div
          className="bubble-container"
          style={{
            pointerEvents: showContent ? "none" : "auto",
          }}
        >
          <div id="bubble" className="main-bubble" onClick={handleBubbleClick} />
        </div>
      </div>
    </Layout>
  );
};

export default Home;